import { supabase } from '@/lib/supabase'

export async function fetchHubProjects() {
  const { data, error } = await supabase.from('hub_projects').select('*').order('updated_at', { ascending: false })

  if (error) return { data: null, error }

  const sorted = [...(data || [])].sort((a, b) => {
    const pa = Number(a.priority) || 0
    const pb = Number(b.priority) || 0
    if (pb !== pa) return pb - pa
    return new Date(b.updated_at) - new Date(a.updated_at)
  })

  return { data: sorted, error: null }
}
